import React from "react";
import { useTranslation } from "react-i18next";

const FloatingContactButton = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-6 left-6 z-50">
      {/* Main floating button */}
      <div className="relative">
        <a
          href="tel:514-979-8020"
          className="group flex items-center justify-center bg-primary-500 hover:bg-primary-600 text-white rounded-full shadow-xl hover:shadow-2xl transform transition-all duration-300 ease-in-out relative z-10 w-14 h-14 hover:w-48 hover:px-4 hover:py-3"
        >
          {/* Phone icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="transition-all duration-300 ease-in-out flex-shrink-0 h-6 w-6 group-hover:h-5 group-hover:w-5 group-hover:mr-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
            />
          </svg>

          {/* Expanded text */}
          <span className="whitespace-nowrap font-semibold transition-all duration-300 ease-in-out opacity-0 max-w-0 overflow-hidden group-hover:opacity-100 group-hover:max-w-xs">
            {t("floatingContact.contactUs")}
          </span>
        </a>

        {/* Pulse animation */}
        <div className="absolute inset-0 bg-primary-400 rounded-full animate-ping opacity-20 pointer-events-none -z-10"></div>
      </div>
    </div>
  );
};

export default FloatingContactButton;
